import React, { useMemo } from 'react';
import { SplitFactoryProvider } from '@splitsoftware/splitio-react';
import { useAuth } from './AuthContext';
import { appSettings } from '../appSettings';

interface SplitProviderProps {
  children: React.ReactNode;
}

/**
 * Wraps the app in the Split.io SDK context.
 * Uses the authenticated user's email as the traffic key so that
 * per-user targeting rules (e.g. ACARS_2_0 on/off) are evaluated correctly.
 * Falls back to 'anonymous' when the user is not yet authenticated.
 * When HARNESSKEY is not configured, uses 'localhost' mode (all treatments
 * return 'control', which is !== 'on', so the classic UI renders by default).
 */
const SplitProvider: React.FC<SplitProviderProps> = ({ children }) => {
  const { userData } = useAuth();
  const email = userData?.profile?.email as string | undefined;

  const config = useMemo<SplitIO.IBrowserSettings>(
    () => ({
      core: {
        authorizationKey: appSettings.HARNESSKEY || 'localhost',
        key: email ?? 'anonymous',
      },
    }),
    [email]
  );

  return <SplitFactoryProvider config={config}>{children}</SplitFactoryProvider>;
};

export default SplitProvider;
